export default [
  {
    path: '/whd_customer',
    component: resolve => require(['./WhdCustomer.vue'], resolve),
    name: 'whd_customer',
    leaf: true//只有一个节点
  }
]
